import type { Event, Store } from 'effector'

import { combine, createStore } from 'effector'
import { T } from './boolean'

/**
 * Route render runs in parallel with init, so Fx.pending is still false on
 * first paint. Treat an unsettled details visit as loading until the primary
 * entity exists, the request fails, or it settles empty.
 */
export function createUnsettledDetailsLoading({
  $isOnThePage,
  $entity,
  $pending,
  settled,
  failed,
  resetOn,
}: {
  $isOnThePage: Store<boolean>
  $entity: Store<unknown>
  $pending: Store<boolean>
  settled: Event<unknown>
  failed: Event<unknown>
  resetOn: Event<unknown>[]
}): Store<boolean> {
  const $hasSettled = createStore(false).on(settled, T).reset(resetOn)
  const $hasFailed = createStore(false).on(failed, T).reset(resetOn)

  return combine(
    $isOnThePage,
    $entity,
    $pending,
    $hasSettled,
    $hasFailed,
    (onPage, entity, pending, hasSettled, hasFailed) =>
      onPage && !entity && !hasFailed && (pending || !hasSettled)
  )
}
